//Tracking
export const ID_ENTIDAD = 3;

//General
export const APPLICATION_ID = 10;
export const NEW_APPLICATION_ID = 5;

export const ID_SOCIAL_SECURITY_NUMBER = 11;

export const PRODUCT_ID = process.env.REACT_APP_PRODUCT_ID;

export const ENTITY_ID = 34;

export const SUPPLIER_ID = 11;

/**
 * IDs de cursos que, al aprobarse el examen, disparan el flujo de
 * firma de contrato (eSignatures + creación de asesor en Ubikme).
 * Antes solo había uno hardcoded por `code`
 * (`nivel-basico-real-vision`) y ni siquiera matcheaba con el `code`
 * real del curso 31 en BD (`basico-real-vision`) — así que la firma
 * NO se disparaba. Ahora son varios cursos (6, 11, 31, 32) y se
 * detectan por ID, más estable que el code (que cambia al renombrar).
 *
 * Configurable por env var `REACT_APP_CONTRACT_COURSE_IDS` (CSV de
 * enteros). Fallback: 6, 11, 31, 32.
 */
const _rawContractIds =
    process.env.REACT_APP_CONTRACT_COURSE_IDS || "6,11,31,32";
export const CONTRACT_COURSE_IDS = new Set(
    _rawContractIds
        .split(",")
        .map((s) => Number(String(s).trim()))
        .filter((n) => Number.isInteger(n) && n > 0)
);

/** True si al aprobar el examen del curso hay que iniciar el flujo de
 *  firma. `courseId` puede venir como string (localStorage) o number. */
export const requiresContract = (courseId) =>
    CONTRACT_COURSE_IDS.has(Number(courseId));

/* Legado — se conserva por compatibilidad con imports pendientes de
   migración. Se actualiza al code REAL del curso 31, aunque la
   detección ya no depende de este valor. */
export const COURSES_CODE = {
    REAL_VISION: 'basico-real-vision'
}

export const CONTRACT_TEMPLATE_ID = "750b182f-1161-4081-bfb9-86e7aae1f3b4"

export const WAY_TO_PAY_ID = {
    TF: 2, //Tranfer
    EW: 1, //E-Wallet
    CC: 3 //Credit Card
}

export const UBIKME_USER_TYPE = {
    AGENT: 7
}
export const UBIKME_ROLE = {
    ASESOR: 4
}

export const UBIKME_AGENCY_ID = 4